"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ror32 = exports.ror16 = exports.ror8 = exports.ror = void 0;
const ror = (numBits) => (shift, value) => ((value >>> shift) | (value << (-shift & (numBits - 1)))) >>> 0;
exports.ror = ror;
exports.ror8 = (0, exports.ror)(8);
exports.ror16 = (0, exports.ror)(16);
exports.ror32 = (0, exports.ror)(32);
